import { getHomepageSlots } from '@/api/library'

export default {
  namespaced: true,
  state: {
    homepageSlots: { univ: [], pub: [] }
  },
  mutations: {
    SET_HOMEPAGE_SLOTS(state, slots) {
      state.homepageSlots = slots
    }
  },
  actions: {
    async fetchHomepageSlots({ commit }) {
      const res = await getHomepageSlots()
      commit('SET_HOMEPAGE_SLOTS', res.data || { univ: [], pub: [] })
    }
  }
}
